/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=a8a4d5ca"
const script = {}

import "./index.vue?vue&type=style&index=0&id=a8a4d5ca&lang=css"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__